import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Hero() {
  return <section className="w-full bg-dark-navy py-16 md:py-24 px-6" data-id="element-26">
      <div className="max-w-6xl mx-auto" data-id="element-27">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-28">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-29">
            <div className="flex items-center gap-3 mb-6" data-id="element-30">
              <ShieldCheckIcon className="w-8 h-8 text-cyan" data-id="element-31" />
              <span className="text-cyan font-semibold uppercase tracking-wider text-sm" data-id="element-32">
                Manual Táctico para Padres
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-oswald text-gold leading-tight mb-6" data-id="element-33">
              Guía de Supervivencia Social y Digital: Cómo proteger a tu hijo de
              las "malas juntas" y la presión de TikTok
            </h1>

            <p className="text-xl md:text-2xl text-gray-300 font-semibold mb-8 leading-relaxed" data-id="element-34">
              (sin convertirte en un policía)
            </p>

            <p className="text-lg text-gray-400 leading-relaxed mb-8" data-id="element-35">
              El manual táctico para padres latinos en USA que quieren recuperar
              la autoridad, detectar amistades tóxicas y blindar a sus hijos
              contra los peligros del "algoritmo" en 21 días.
            </p>

            <motion.a href="#comprar" onClick={e => {
            e.preventDefault();
            document.getElementById('comprar')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="inline-block bg-gold text-dark-navy px-8 py-4 rounded-lg font-bold text-lg hover:bg-yellow-400 transition-colors shadow-lg cursor-pointer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} data-id="element-36">
              ¡QUIERO LA GUÍA AHORA!
            </motion.a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-37">
            <div className="relative z-10" data-id="element-38">
              <img src="https://cdn.magicpatterns.com/uploads/j1NJkKetmZehVhmGKr59YM/Tapa_final.png" alt="Guía de Supervivencia Social y Digital" className="w-full h-auto rounded-lg shadow-2xl" data-id="element-39" />
            </div>
            <div className="absolute inset-0 bg-cyan opacity-20 blur-3xl -z-10" data-id="element-40"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}